import React, { useMemo } from "react";
import { Box, Image, Text, Flex, Stack } from "@chakra-ui/react";
import { Auth } from "aws-amplify";
import { SectionMain } from "./components/SectionMain";
import { AuthSection } from "./components/AuthSection";
import { PublisherAndUserContext } from "./contexts/PublisherAndUserContext";
import { useLogin } from "./hooks/useLogin";
import { DeactivatedAccountPage } from "./pages/DeactivatedAccountPage";
import './App.scss';

function App() {
  const [isLoggedin, user, publisher, userRole, loading, updatePublisherState] = useLogin(Auth);

  if (loading) {
    return (
      <Flex
        justifyContent="center"
        alignItems="center"
        height="100vh"
        weight="100%"
        background="#f7fafc"
      >
        <Flex flexDirection="column" alignItems="center">
          <span display="block" className="dloader" textAlign="center"></span>
          <Text fontFamily="Halant, serif" fontWeight="medium" fontSize="6xl" letterSpacing="0.3px">Edshopify</Text>
        </Flex>
      </Flex>
    )
  }

  return (
    <Box className="App" position="relative" width="100%">
      {
        isLoggedin ?
          user.isActive ?
            <PublisherAndUserContext.Provider value={{ user, publisher, userRole, updatePublisherState }}>
              <SectionMain />
            </PublisherAndUserContext.Provider> :
            <DeactivatedAccountPage />
          : <AuthSection />
      }
    </Box>
  );
}

export default App;
